import { rightsholderBase2v } from '@App/dicts/pathes'

export const overclaimViewByHeaderId = (overclaimHeaderId: number, rightsholderId: number) =>
    rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}`)
export const overclaimHistoryByHeaderId = (overclaimHeaderId: number, rightsholderId: number) =>
    rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/history`)
export const overclaimStatusCounts = (rightsholderId: number) =>
    rightsholderBase2v(rightsholderId, 'search/overclaims/status-counts')
export const sendOverclaimEmail = (overclaimHeaderId: number, rightsholderId: number) =>
    rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/email`)
export const renderOverclaimEmailTemplate = (overclaimHeaderId: number, rightsholderId: number) =>
    rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/email-template`)
export const amendOverclaimShares = (overclaimHeaderId: number, rightsholderId: number) =>
    rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/amend`)
export const bulkAmendOverclaimShares = (rightsholderId: number) =>
    rightsholderBase2v(rightsholderId, `overclaim/bulk/amend`)
export const createRelinquishment = (rightsholderId: number, overclaimHeaderId: number) =>
    rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/create-relinquishment`)
export const createBulkRelinquishment = (rightsholderId: number) =>
    rightsholderBase2v(rightsholderId, `overclaim/bulk/create-relinquishment`)
export const getRelinquishments = (rightsholderId: number, overclaimHeaderId: number) =>
    rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/relinquishments`)

// Overclaim Document Upload paths
export const uploadDocumentForOverclaim = (rightsholderId: number, overclaimHeaderId: number) =>
    rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/upload`)
export const finalizeDocumentUpload = (rightsholderId: number, memberUploadId: number) =>
    rightsholderBase2v(rightsholderId, `upload/${memberUploadId}/finalize`)
export const bulkUploadDocumentForOverclaims = (rightsholderId: number) =>
    rightsholderBase2v(rightsholderId, `overclaim/bulk/upload`)
export const updateOverclaimDocumentDescription = (
    rightsholderId: number,
    overclaimHeaderId: number,
    memberUploadId: number
) => rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/upload/${memberUploadId}`)
export const getOverclaimUploadDocumentDownload = (
    rightsholderId: number,
    overclaimId: number,
    memberUploadId: number
) => rightsholderBase2v(rightsholderId, `overclaim/${overclaimId}/upload/${memberUploadId}/download`)
export const searchOverclaimDocuments = (rightsholderId: number, overclaimId: number) =>
    rightsholderBase2v(rightsholderId, `overclaim/${overclaimId}/document/search`)
export const attachExistingOverclaimDocument = (rightsholderId: number, overclaimHeaderId: number) =>
    rightsholderBase2v(rightsholderId, `overclaim/${overclaimHeaderId}/upload/attach`)
